// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"83":"036bb021","222":"521c219c","478":"1d6c1417","772":"e80743d9","810":"55bb3324","812":"a3085d85","860":"28242388"}[chunkId] + ".chunk.js";
};